import * as actionTypes from "../actions/actionTypes";

const initialState = {
  suggests: [],
};

const suggestReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_SUGGESTS:
      return {
        ...state,
        suggests: [...action.suggests],
      };

    default:
      return state;
  }
};

export default suggestReducer;
